"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWithCustomQuery = void 0;
var requestWithCustomQuery = function (type, query, variables) {
    return {
        type: type,
        payload: {
            query: query,
            variables: variables,
        },
        meta: {
            isApiCall: true,
            isCustomQuery: true,
        },
    };
};
exports.requestWithCustomQuery = requestWithCustomQuery;
//# sourceMappingURL=actions.js.map